import React from "react";
import styled from "styled-components";
import { body01, label01 } from "../styles";
const OrgNameWrapper = styled.div `
	display: flex;
	padding-right: var(--12-px-075-rem-spacing-04, 12px);
	align-items: center;
	gap: var(--16-px-1-rem-spacing-05, 16px);
	align-self: stretch;
`;
const SuperOrgWrapper = styled.div `
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: var(--0-px-0-rem-spacing-00, 0px);
`;
const SuperOrgName = styled.div `
	color: var(--cds-text-secondary, #c6c6c6);
	${label01}
`;
const TeamName = styled.div `
	color: var(--cds-text-primary, #f4f4f4);
	text-align: right;
	${body01}
`;
const SingleOrgName = styled.div `
	font-size: 14px;
	line-height: 3rem;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	max-width: 150px;
`;
export const OrgName = ({ orgName, isSuperOrg, activeSuperOrg }) => (React.createElement(OrgNameWrapper, null, activeSuperOrg && !isSuperOrg ? (React.createElement(SuperOrgWrapper, { title: orgName },
    React.createElement(SuperOrgName, null, activeSuperOrg),
    React.createElement(TeamName, null, orgName))) : (React.createElement(SingleOrgName, { className: "bodyText", title: orgName }, orgName))));
